import { FunctionComponent, useContext, useState, useEffect } from 'react';
import classnames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { counterTrigger } from 'Tools/counters';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import { PET_NAMES } from 'Tools/pets';
import { AddPetContext } from 'Src/components/AddPet/AddPet';
import 'Styles/pets.css';
import * as s from './FirstStep.css';
import Pet from './FirstStepPet';
import CatIcon from './img/cat.svg';
import DogIcon from './img/dog.svg';
import Text from '@media-ui/core/src/components/Text';
import Cat2022Icon from './img/cat2022.svg';
import Dog2022Icon from './img/dog2022.svg';
import PetsshopCatIcon from './img/petsshop-cat.svg';
import PetsshopDogIcon from './img/petsshop-dog.svg';
const FIELD_NAME = 'pet';
const FirstStep: FunctionComponent = () => {
    const addPetContext = useContext(AddPetContext);
    const { isPetsshop, viewType, step } = addPetContext || {};
    const { clearErrors, register, setValue, getValues, errors } = useFormContext();
    const valueFromForm = getValues(FIELD_NAME);
    const [active, setActive] = useState(valueFromForm);
    const texts = {
        default: 'Получите доступ к бесплатным консультациям ветеринара',
        petsshop: 'Выберите, кого хотите побаловать вкусняшкой',
        year2022: 'И бесплатно задавайте вопросы ветеринарам и зоопсихологам',
    };
    const noticeText = texts[viewType as keyof typeof texts];
    const noticeClasses = classnames(s.notice, {
        [s.noticePetsshop]: isPetsshop,
    });
    const rootClasses = classnames(s.root, {
        [s.rootYear2022]: viewType === 'year2022' && (step === 0 || step === 1),
    });
    const dogIcons = {
        default: <DogIcon />,
        petsshop: <PetsshopDogIcon />,
        year2022: <Dog2022Icon />,
    };
    const catIcons = {
        default: <CatIcon />,
        petsshop: <PetsshopCatIcon />,
        year2022: <Cat2022Icon />,
    };
    useEffect(() => {
        counterTrigger('addPetWindowFirstStep');
        if (!valueFromForm)
            register({ name: FIELD_NAME, type: 'custom' }, { required: true });
    }, []);
    const handleClick = (val: string): void => {
        setValue(FIELD_NAME, val);
        setActive(val);
        snitchCounter('addPetFormTypePick', {
            petType: PET_NAMES[val as keyof typeof PET_NAMES],
        });
    };
    if (Object.keys(errors).length) {
        clearErrors();
    }
    return (<section className={rootClasses}>
      <Text tag="div" className={noticeClasses}>
        {noticeText}
      </Text>
      <div className={s.pets}>
        <Pet value={'1'} active={active || valueFromForm} setActive={handleClick} title="Собака">
          {dogIcons[viewType as keyof typeof dogIcons]}
        </Pet>
        <Pet value={'2'} active={active || valueFromForm} setActive={handleClick} title="Кошка">
          {catIcons[viewType as keyof typeof catIcons]}
        </Pet>
      </div>
    </section>);
};
export default FirstStep;
